import * as types from './types';

export const addItemToBasket = item => ({type: types.ADD_ITEM, payload: item });
export const minusItemCount = itemId => ({type: types.MINUS_ITEM_COUNT, payload: itemId });
export const plusItemCount = itemId => ({type: types.PLUS_ITEM_COUNT, payload: itemId });
export const setItemCount = (itemId, count) => ({type: types.SET_ITEM_COUNT, payload: {itemId, count}})
export const resetBasket = () => ({type: types.RESET_BASKET, payload: {}})
